import React, { Component } from "react";
import { Elements } from "react-stripe-elements";
import Select from "react-select";
import countryList from "react-select-country-list";

import CheckoutForm from "./check-out-form";
import AgencyPricingSelect from "./pricing-select";
import SignUpInput from "./input";
import "./style.scss";

class SignUpAgency extends Component {
  constructor(props) {
    super(props);

    this.options = countryList().getData();

    this.state = {
      loadingState: false,
      errorState: false,
      setupState: false,
      cardNotice: undefined,
      country: "",
      options: this.options,
      accountPackage: "small",
      paymentInterval: "year",
      form: {},
    };
  }

  componentDidMount = () => {
    let accountPackage = "small";
    if (window.location.hash.includes("medium")) {
      accountPackage = "medium";
    }
    if (window.location.hash.includes("large")) {
      accountPackage = "large";
    }

    this.setState({ accountPackage });
  };

  setData = (event) => {
    this.setState({
      form: {
        ...this.state.form,
        [event.target.name]: event.target.value,
      },
      errorState: false,
    });
  };

  setCountry = (value) => {
    this.setState({
      country: value,
      form: {
        ...this.state.form,
        country: value.value,
      },
      errorState: false,
    });
  };

  setError = (errorState) => {
    this.setState({ errorState: errorState });
  };

  setLoading = (loadingState) => {
    this.setState({ loadingState: loadingState });
  };

  setSetup = (setupState) => {
    this.setState({ setupState: setupState });
  };

  setCardNotice = (cardNotice) => {
    this.setState({ cardNotice });
  };

  updatePaymentInterval = (event) => {
    this.setState({ paymentInterval: event.target.value });
  };

  changePaymentInterval = (value) => {
    this.setState({ paymentInterval: value });
  };

  render() {
    const { accountPackage, paymentInterval } = this.state;

    return (
      <section className="aboss__body aboss__body-signup-agency">
        <div className="aboss__signup-agency-container">
          <h1 className="aboss__signup-agency-package">
            Sign up for Agency {accountPackage.substr(0, 1).toUpperCase()}
            {accountPackage.substr(1)}
          </h1>
          {this.state.setupState && (
            <div
              style={{
                width: "70%",
                margin: "25 auto",
                fontSize: "17px",
                fontWeight: "500",
                textAlign: "center",
                color: "#fff",
              }}
            >
              <div
                style={{
                  margin: "0 auto 35px auto",
                  width: "100%",
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              Your ABOSS Agency has been setup, you will receive an email
              shortly with all the required information to get started.
            </div>
          )}
          {!this.state.setupState && (
            <div
              className={`aboss__signup-agency-block ${
                this.state.loadingState ? "loading" : ""
              }`}
            >
              {this.state.loadingState && (
                <div className="aboss__signup-agency-loading">
                  <div className="spinner">
                    <div className="double-bounce1"></div>
                    <div className="double-bounce2"></div>
                  </div>
                </div>
              )}
              <div className="aboss__signup-agency-select">
                <AgencyPricingSelect
                  accountPackage={accountPackage}
                  paymentInterval={paymentInterval}
                  updatePaymentInterval={this.updatePaymentInterval}
                  changePaymentInterval={this.changePaymentInterval}
                />
              </div>
              <div className="aboss__signup-agency-form">
                <h1>Contact Details</h1>
                <SignUpInput
                  label="Company name"
                  name="company_name"
                  onChange={this.setData}
                  placeholder="The name of the legal Company"
                  required={false}
                />
                <div className="form-row half-container">
                  <SignUpInput
                    label="First name"
                    name="first_name"
                    onChange={this.setData}
                    placeholder="First name"
                    required={true}
                  />
                  <SignUpInput
                    label="Last name"
                    name="last_name"
                    onChange={this.setData}
                    placeholder="Last name"
                    required={true}
                  />
                </div>
                <SignUpInput
                  label="Email Address"
                  name="email"
                  type="email"
                  onChange={this.setData}
                  placeholder="john@example.com"
                  required={true}
                />
                <div className="form-row half-container">
                  <SignUpInput
                    label="Streetname"
                    name="street"
                    onChange={this.setData}
                    placeholder="Streetname"
                    required={true}
                  />
                  <SignUpInput
                    label="Postalcode"
                    name="postalcode"
                    onChange={this.setData}
                    placeholder="Postalcode"
                    required={true}
                  />
                </div>
                <div className="form-row half-container">
                  <SignUpInput
                    label="City"
                    name="city"
                    onChange={this.setData}
                    placeholder="City"
                    required={true}
                  />
                  <div className="form-row">
                    <label htmlFor="email">Country *</label>
                    <Select
                      options={this.state.options}
                      value={this.state.country}
                      onChange={this.setCountry}
                      className="aboss__signup-agency-select-country"
                      classNamePrefix="aboss__select"
                    />
                  </div>
                </div>
                <SignUpInput
                  label="Tax Number"
                  name="tax_number"
                  onChange={this.setData}
                  placeholder="Tax Number"
                  required={false}
                />
                <SignUpInput
                  label="How did you find out about us?"
                  name="how_did_you"
                  onChange={this.setData}
                  placeholder="How did you find out about us?"
                  required={false}
                />
                <h1 style={{ marginTop: "50px" }}>Agency Details</h1>
                <SignUpInput
                  label="Agency name"
                  name="agency_name"
                  onChange={this.setData}
                  placeholder="The name of your Agency"
                  required={true}
                />
                <h1 style={{ marginTop: "50px" }}>Coupon code</h1>
                <SignUpInput
                  label="Coupon code"
                  name="coupon_code"
                  onChange={this.setData}
                  placeholder="Have a coupon code?"
                  required={false}
                />
                {this.state.form.coupon_code === "2020trial" &&
                  paymentInterval === "month" && (
                    <div class="form-row-action">
                      <span>The first month is free!</span> After the first
                      month we'll automatically bill you, you can cancel your
                      subscription at anytime during the trial period.
                    </div>
                  )}
                {this.state.form.coupon_code === "2020trial" &&
                  paymentInterval === "year" && (
                    <div class="form-row-action">
                      <span>
                        This coupon is only available with a monthly
                        subscription.
                      </span>
                    </div>
                  )}
                <h1 style={{ marginTop: "50px" }}>Card Details</h1>
                <div className="aboss__signup-agency-form-card">
                  <Elements>
                    <CheckoutForm
                      form={this.state.form}
                      accountPackage={accountPackage}
                      paymentInterval={paymentInterval}
                      loadingState={this.state.loadingState}
                      errorState={this.state.errorState}
                      cardNotice={this.state.cardNotice}
                      setLoading={this.setLoading}
                      setError={this.setError}
                      setSetup={this.setSetup}
                      setCardNotice={this.setCardNotice}
                      {...this.props}
                    />
                  </Elements>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default SignUpAgency;



// WEBPACK FOOTER //
// src/views/sign-up-agency/index.js